import { HoverText, Icon } from '@advanza/ui'
import CalendarPicker from 'components/services/CalendarPicker'
import Service from 'interfaces/Services'
import { ReactNode } from 'react'

interface Props {
    entity: Service
    onChangeEntity: (diff: Partial<Service>, additional?: Record<string, unknown>) => void
    renderInput: (name: string, saveAfterChange?: boolean) => ReactNode
    className?: string
}

/**
 * Calendar settings
 *
 * This component contains all the calendar related service settings.
 */
const CalendarSettings = ({ entity, onChangeEntity, renderInput, className }: Props) => {
    return (
        <div className={className}>
            <div className="flex gap-2">
                <b>Calendar settings</b>
                <HoverText trigger={<Icon name="info" fontSize={16} />}>
                    <b>Rules for the day/month pickers</b>:
                    <ul>
                        <li>Day/month pickers are not allowed as after conversion questions.</li>
                        <li>Day/month pickers are always used as filter question.</li>
                        <li>
                            Day/month pickers can be marked as optional (the system will provide a
                            fallback text).
                        </li>
                        <li>
                            When a day/month picker is enabled, providers can block certain calendar
                            items in their dashboard. Switching or removing a day/month from a
                            service is therefore not advised without informing the providers.
                        </li>
                    </ul>
                    <br />
                    <b>Rules for the moment picker</b>:
                    <ul>
                        <li>
                            A moment picker question cannot be an availability question and an after
                            conversion question at the same time. Pick one.
                        </li>
                        <li>
                            A moment picker can only be filterable if the opening hours are enabled.
                        </li>
                        <li>
                            A moment picker can be marked as optional (the system will provide a
                            fallback text).
                        </li>
                        <li>
                            A moment picker is allowed to be combined with a day/month picker, but
                            not as availability question, as there should not be two types of
                            availability questions in the wizard.
                        </li>
                    </ul>
                </HoverText>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 my-2">
                {renderInput('enable_moment_picker')}
                {renderInput('enable_opening_hours')}
            </div>
            <CalendarPicker entity={entity} onChangeEntity={onChangeEntity} />
        </div>
    )
}

export default CalendarSettings
